{
  "iFrame" : {
    "insecure": "Cannot load frame over http",
    "consentModal": {
      "body": "You need (delicious) cookies to view this content",
      "buttonText": "Accept third-party cookies"
    }
  }
}
